<template>
  <div class="page page-project">
    <div class="page__wrap" data-animate="page-wrap" v-if="project">
      <header class="row-1 p-top-5" ref="text">
        <NavigationBackLink
          class="m-bot-5"
          data-animate="header-content"
          :link="{
            title: $t('pages.projects.backLinkProjects'),
            route: {
              name: 'projects',
            },
          }"
        />

        <p
          class="text-uppercase text-s"
          data-animate="header-content"
          v-if="project.projectType.length"
        >
          {{ project.projectType.join(', ') }}
        </p>
        <!-- Titolo  -->
        <h1 data-animate="header-title" class="title-m">
          {{ project.title }}
        </h1>

        <!-- Picture -->
        <div
          v-if="project.cover?.[0]"
          class="m-top-4"
          data-animate="header-image"
        >
          <WidgetPicture
            :image="{
              custom: project.cover?.[0],
            }"
            :alt="project.cover?.[0]?.title"
            :lazyLoad="true"
          />
        </div>
      </header>
      <!-- Editorial -->
      <div class="p-bot-3 m-top-4" data-animate="page-content">
        <LazyEditorialList
          v-if="project?.editorialContent?.length"
          :content="project.editorialContent"
        />
      </div>

      <div v-if="latest.length" class="p-bot-3">
        <div class="row-1">
          <div
            class="p-top-5 page-project__latest flex --justify-space-between --align-center"
          >
            <h2 class="title-m m-right-16px flex-1" v-anim-reveal-text>
              {{ $t('pages.projects.otherTitle') }}
            </h2>

            <LazyWidgetLinkMainUnderline
              :link="{ key: 'view-all', route: { name: 'projects' } }"
            />
          </div>
        </div>
        <div
          class="m-top-4 text-l page-related-link__swiper"
          v-anim-parallax-element="{
            target: 'picture',
            offset: 10,
          }"
        >
          <WidgetSliderSwiper :slides="latest" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/editorial.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Fetch Craft
const { configuration } = useCraftStore()
const route = useRoute()

const query = queries.projects.getProject
const variables = computed(() => ({
  site: configuration.site,
  projectSlug: route.params.slug,
}))
const { data } = await useGraphql(query, variables)

if (!data.value?.projectsEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const project = computed(() => data.value?.projectsEntries?.[0])
const latest = computed(() =>
  data.value?.latest
    .filter((project) => project.slug !== route.params.slug)
    .map((project) => ({
      title: project.title,
      cover: project.cover?.[0],
      route: {
        name: 'projects-slug',
        params: { slug: project.slug },
      },
    }))
)

const seo = computed(() => data.value?.projectsEntries?.[0]?.seo || {})
const localeParams = computed(
  () => data.value?.projectsEntries?.[0]?.localized || {}
)

// Seo
useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
})
</script>
